import * as core from '../../../../../../../core'

import { query } from './edit-activity.query'

export const RESOURCE = {
  payload: {
    alias: 'sr.conditions.widgets.add-activity',
    description: 'Edit Monitoring Activity',
    name: 'Edit Monitoring Activity',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
